<template>
  <v-form>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span> <div>Аттестационное дело соискателя</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text v-if="lang.length > 0">
            <div v-if="setDisable('0')">

              <v-layout wrap>
                <v-flex md4>
                  <v-card-text class="text-xs-left subheading">
                    Фамилия:
                  </v-card-text>
                  <div v-for="item, i in value.lastName">
                    <v-text-field
                      :error="hasError('lastName')"
                      :error-messages="getError('lastName')"
                      :label=findLang(value.lastName[i].language)
                      required
                      outline
                      v-model="value.lastName[i].text"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </div>
                </v-flex>

                <v-flex md4>
                  <v-card-text class="text-xs-left subheading">
                    Имя:
                  </v-card-text>
                  <div v-for="item, i in value.firstName">
                    <v-text-field
                      :error="hasError('firstName')"
                      :error-messages="getError('firstName')"
                      :label=findLang(value.firstName[i].language)
                      required
                      outline
                      v-model="value.firstName[i].text"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </div>
                </v-flex>

                <v-flex md4>
                  <v-card-text class="text-xs-left subheading">
                    Отчество:
                  </v-card-text>
                  <div v-for="item, i in value.patronymic">
                    <v-text-field
                      :error="hasError('patronymic')"
                      :error-messages="getError('patronymic')"
                      :label=findLang(value.patronymic[i].language)
                      required
                      outline
                      v-model="value.patronymic[i].text"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </div>
                </v-flex>

              </v-layout>
              <v-flex md4>
                <v-text-field
                  :error="hasError('birthday')"
                  :error-messages="getError('birthday')"
                  label= 'Дата рождения'
                  required
                  type="date"
                  outline
                  v-model="value.birthday"
                  class="pa-1 ma-1"
                > </v-text-field>
              </v-flex>
              <v-layout wrap>

                <v-flex md6>
                  <v-card-text class="text-xs-left subheading">
                    Тема диссертационной работы
                  </v-card-text>
                  <div v-for="item, i in value.thesisTopic">
                    <v-text-field
                      :error="hasError('thesisTopic')"
                      :error-messages="getError('thesisTopic')"
                      :label=findLang(value.thesisTopic[i].language)
                      required
                      outline
                      v-model="value.thesisTopic[i].text"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </div>

                </v-flex>
                <v-flex md6>
                  <v-autocomplete
                    :error="hasError('language')"
                    :error-messages="getError('language')"
                    :items="lang"
                    label="Язык защиты"
                    v-model="value.language"
                    item-value="id"
                    item-text="name"
                    no-data-text="Нет данных"
                    class="pa-1 ma-1"
                  ></v-autocomplete>
                  <v-layout>
                    <v-autocomplete
                      :error="hasError('academicDegree')"
                      :error-messages="getError('academicDegree')"
                      :items="selectors.academicDegree"
                      label="Ученая степень"
                      v-model="value.academicDegree"
                      no-data-text="Нет данных"
                      class="pa-1 ma-1"
                    ></v-autocomplete>
                    <v-card-text>{{textAcadem}}</v-card-text>
                  </v-layout>

                  <v-autocomplete
                    :error="hasError('organization')"
                    :error-messages="getError('organization')"
                    :items="selectors.organization"
                    label="Организация, в которой выполнена работа"
                    v-model="value.organization"
                    no-data-text="Нет данных"
                    class="pa-1 ma-1"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="addOrganization = true"
                      >
                        <v-list-tile-action>
                          <v-icon>add</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Добавить новую организацию</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>

                  </v-autocomplete>

                  <v-autocomplete
                    class="pa-1 ma-1"
                    :error="hasError('dissertationCouncil')"
                    :error-messages="getError('dissertationCouncil')"
                    :items="selectors.dissertationCouncil"
                    label="Диссертационный совет"
                    v-model="value.dissertationCouncil"
                    no-data-text="Нет данных"
                  ></v-autocomplete>
                </v-flex>

              </v-layout>

              <v-layout v-for="item, i in  value.scientificField" v-if="(isSecretary() &&  Number(value.status) > 2) || !isSecretary()">
                <v-autocomplete
                  :error="hasError('scientificField')"
                  :error-messages="getError('scientificField')"
                  :items="selectors.scientificField"
                  label="Научная специальность (по отраслям науки)"
                  v-model="item.scientificField"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                ></v-autocomplete>

                <div v-if="!isOnlyRead()">
                  <v-btn flat icon class="primary" @click="addField('scientificField')">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn flat icon class="primary" v-if="value.scientificField.length > 1"
                         @click="deleteData(i,'scientificField')">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>

              </v-layout>

              <div  v-if="(isSecretary() &&  Number(value.status) > 2) || !isSecretary()" >
                <v-layout  v-if="!isOnlyRead()">
                  <v-card-text class="text-xs-left title">Добавить научных руководителей:</v-card-text>
                  <v-btn flat icon class="primary" @click="addField_scientific_boss">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-layout>

                <div v-if="value.scientificBoss !== null">
                  <v-layout v-for="item, i in  value.scientificBoss">


                    <input @change="setFile($event,'scientificBoss',i,'review')"
                           accept="application/pdf,application/vnd.ms-excel" name="image"
                           :ref="'scientificBossinputUploadFile_'+i"
                           style="font-size: 1.2em; padding: 10px 0;"
                           type="file"
                           v-show="false"/>
                    <v-layout wrap>

                      <v-autocomplete
                        class="pa-1 ma-1"
                        :error="hasError('person')"
                        :error-messages="getError('person')"
                        :items="selectors.scientificBoss"
                        label="Научный руководитель"
                        v-model="value.scientificBoss[i].person"
                        no-data-text="Нет данных"
                      >
                        <template v-slot:prepend-item>
                          <v-list-tile
                            ripple
                            @click="addPerson = true"
                          >
                            <v-list-tile-action>
                              <v-icon>add</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>

                      <v-input
                        :error="hasError('scientificBoss')"
                      >
                        Прикрепленный файл отзыв научного руководителя: <a v-if="value.scientificBoss[i].review !==''
                              && typeof value.scientificBoss[i].review !== 'object'"
                                                                           :href="value.scientificBoss[i].review"
                                                                           target="_blank" rel="noopener noreferrer">Файл
                        изменений</a>
                        <div
                          v-if="typeof value.scientificBoss[i].review === 'object' && value.scientificBoss[i].review !== null">
                          {{value.scientificBoss[i].review.name}}
                        </div>

                      </v-input>
                      <div v-if="!isOnlyRead()">
                        <v-btn v-if="typeof value.scientificBoss[i].review === 'object'
                                                 && value.scientificBoss[i].review !== null" color="primary" flat
                               @click="value.scientificBoss[i].review = null">
                          <v-icon>close</v-icon>
                          Открепить
                        </v-btn>

                        <v-btn v-else @click="$refs['scientificBossinputUploadFile_'+i][0].click()"
                               color="primary"
                               flat>
                          <v-icon>folder_open</v-icon>
                          Прикрепить
                        </v-btn>
                      </div>

                    </v-layout>

                    <v-btn flat icon class="primary"  v-if="!isOnlyRead()"
                           @click="deleteData(i,'scientificBoss',true)">
                      <v-icon>close</v-icon>
                    </v-btn>

                  </v-layout>
                </div>
              </div>

              <v-divider class="pt-2"></v-divider>
              <v-layout v-if="!isOnlyRead()" >
                <v-card-text class="text-xs-left title">Добавить научных консультантов:</v-card-text>
                <v-btn flat icon class="primary" @click="addField_scientific_consultant">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-layout>

              <div v-if="value.scientificConsultant !== null">
                <v-layout v-for="item, i in  value.scientificConsultant">


                  <input @change="setFile($event,'scientificConsultant',i,'review')"
                         accept="application/pdf,application/vnd.ms-excel" name="image"
                         :ref="'inputUploadFile_'+i"
                         style="font-size: 1.2em; padding: 10px 0;"
                         type="file"
                         v-show="false"/>
                  <v-layout wrap>

                    <v-autocomplete
                      class="pa-1 ma-1"
                      :error="hasError('person')"
                      :error-messages="getError('person')"
                      :items="selectors.scientificBoss"
                      label="Научный консультант"
                      v-model="value.scientificConsultant[i].person"
                      no-data-text="Нет данных"
                    >
                      <template v-slot:prepend-item>
                        <v-list-tile
                          ripple
                          @click="addPerson = true"
                        >
                          <v-list-tile-action>
                            <v-icon>add</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>

                    <v-input
                      :error="hasError('scientificConsultant')"
                    >
                      Прикрепленный файл отзыв научного консультанта: <a v-if="value.scientificConsultant[i].review !==''
                && typeof value.scientificConsultant[i].review !== 'object'"
                                                                         :href="value.scientificConsultant[i].review"
                                                                         target="_blank" rel="noopener noreferrer">Файл
                      изменений</a>
                      <div
                        v-if="typeof value.scientificConsultant[i].review === 'object' && value.scientificConsultant[i].review !== null">
                        {{value.scientificConsultant[i].review.name}}
                      </div>

                    </v-input>

                    <v-btn v-if="typeof value.scientificConsultant[i].review === 'object'
               && value.scientificConsultant[i].review !== null" color="primary" flat
                           @click="value.scientificConsultant[i].review = null">
                      <v-icon>close</v-icon>
                      Открепить
                    </v-btn>

                    <v-btn v-else @click="$refs['inputUploadFile_'+i][0].click()"
                           color="primary"
                           flat>
                      <v-icon>folder_open</v-icon>
                      Прикрепить
                    </v-btn>
                  </v-layout>

                  <v-btn flat icon class="primary"
                         @click="deleteData(i,'scientificConsultant',true)">
                    <v-icon>close</v-icon>
                  </v-btn>

                </v-layout>
              </div>
              <v-divider class="pt-2"></v-divider>
            </div>
            <div>
              <div v-if="setDisable('0')">
                <FileInput
                  v-bind:fieldLabel="'заявления'"
                  v-bind:field="'statement'"
                  v-bind:file=value.statement
                  @updateFile="updateFile"
                  v-bind:error="hasError('statement')"
                  v-bind:error_messages="getError('statement')"
                  v-bind:template="setTemplUrl('case.CandidateCase.statement')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'документ об образовании'"
                  v-bind:field="'eduDoc'"
                  v-bind:file=value.eduDoc
                  @updateFile="updateFile"
                  v-bind:error="hasError('eduDoc')"
                  v-bind:error_messages="getError('eduDoc')"
                  v-bind:template="setTemplUrl('case.CandidateCase.eduDoc')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'документ о сдаче кандидатских экзаменов'"
                  v-bind:field="'examDoc'"
                  v-bind:file=value.examDoc
                  @updateFile="updateFile"
                  v-bind:error="hasError('examDoc')"
                  v-bind:error_messages="getError('examDoc')"
                  v-bind:template="setTemplUrl('case.CandidateCase.examDoc')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'заключение организации'"
                  v-bind:field="'organizationConclusion'"
                  v-bind:file=value.organizationConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('organizationConclusion')"
                  v-bind:error_messages="getError('organizationConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.organizationConclusion')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'экспертное заключение о возможности открытого опубликования'"
                  v-bind:field="'expertPublicationConclusion'"
                  v-bind:file=value.expertPublicationConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('expertPublicationConclusion')"
                  v-bind:error_messages="getError('expertPublicationConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.expertPublicationConclusion')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'экспертное заключение о прохождении экспортного контроля на внешнеэкономическую\n'+
'                сделку'"
                  v-bind:field="'expertTradeConclusion'"
                  v-bind:file=value.expertTradeConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('expertTradeConclusion')"
                  v-bind:error_messages="getError('expertTradeConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.expertTradeConclusion')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'согласие на обработку персональных данных'"
                  v-bind:field="'personalDataConsent'"
                  v-bind:file=value.personalDataConsent
                  @updateFile="updateFile"
                  v-bind:error="hasError('personalDataConsent')"
                  v-bind:error_messages="getError('personalDataConsent')"
                  v-bind:template="setTemplUrl('case.CandidateCase.personalDataConsent')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'копия паспорта'"
                  v-bind:field="'passport'"
                  v-bind:file=value.passport
                  @updateFile="updateFile"
                  v-bind:error="hasError('passport')"
                  v-bind:error_messages="getError('passport')"
                  v-bind:template="setTemplUrl('case.CandidateCase.passport')"
                ></FileInput>

                <v-divider class="mt-2"></v-divider>
              </div>
              <div v-if="setDisable('2')">
                <FileInput
                  v-bind:fieldLabel="'Диссертация (PDF)'"
                  v-bind:field="'thesisPDF'"
                  v-bind:file=value.thesisPDF
                  @updateFile="updateFile"
                  v-bind:error="hasError('thesisPDF')"
                  v-bind:error_messages="getError('thesisPDF')"
                  v-bind:template="setTemplUrl('case.CandidateCase.thesisPDF')"
                ></FileInput>


                <FileInput
                  v-bind:fieldLabel="'Автореферат'"
                  v-bind:field="'synopsis'"
                  v-bind:file=value.synopsis
                  @updateFile="updateFile"
                  v-bind:error="hasError('synopsis')"
                  v-bind:error_messages="getError('synopsis')"
                  v-bind:template="setTemplUrl('case.CandidateCase.synopsis')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Аннотация'"
                  v-bind:field="'annotation'"
                  v-bind:file=value.annotation
                  @updateFile="updateFile"
                  v-bind:error="hasError('annotation')"
                  v-bind:error_messages="getError('annotation')"
                  v-bind:template="setTemplUrl('case.CandidateCase.annotation')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Заключение комиссии по русскому языку'"
                  v-bind:field="'expertInternetPublicationConclusion'"
                  v-bind:file=value.expertInternetPublicationConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('expertInternetPublicationConclusion')"
                  v-bind:error_messages="getError('expertInternetPublicationConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.expertInternetPublicationConclusion')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Заключение комиссии по предварительному рассмотрению'"
                  v-bind:field="'expertReviewConclusion'"
                  v-bind:file=value.expertReviewConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('expertReviewConclusion')"
                  v-bind:error_messages="getError('expertReviewConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.expertReviewConclusion')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Протокол заседания диссертационного совета о приеме диссертации к защите'"
                  v-bind:field="'councilReviewProtocol'"
                  v-bind:file=value.councilReviewProtocol
                  @updateFile="updateFile"
                  v-bind:error="hasError('councilReviewProtocol')"
                  v-bind:error_messages="getError('councilReviewProtocol')"
                  v-bind:template="setTemplUrl('case.CandidateCase.councilReviewProtocol')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Явочный лист заседания диссертационного совета о приеме диссертации к защите'"
                  v-bind:field="'councilReviewLeafSheet'"
                  v-bind:file=value.councilReviewLeafSheet
                  @updateFile="updateFile"
                  v-bind:error="hasError('councilReviewLeafSheet')"
                  v-bind:error_messages="getError('councilReviewLeafSheet')"
                  v-bind:template="setTemplUrl('case.CandidateCase.councilReviewLeafSheet')"
                ></FileInput>

                <v-divider class="mt-2"></v-divider>
              </div>
              <div v-if="setDisable('3')">
                <v-layout class="mt-2" wrap>
                  <v-autocomplete
                    class="pa-1 ma-1"
                    :error="hasError('location')"
                    :error-messages="getError('location')"
                    :items="selectors.location"
                    label="Место проведения защиты"
                    v-model="value.location"
                    no-data-text="Нет данных"
                  ></v-autocomplete>

                  <v-text-field
                    :error="hasError('room')"
                    :error-messages="getError('room')"
                    label="Помещение"
                    required
                    v-model="value.room"
                    class="pa-1 ma-1"
                  ></v-text-field>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="value.protectionDate"
                        label="Дата защиты диссертации"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        class="pa-1 ma-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="value.protectionDate"
                                   locale="ru"
                                   :max="ruleDateMax"
                                   :min="ruleDateMin"
                                   @input="menu = false"></v-date-picker>
                  </v-menu>
                  <v-text-field
                    :error="hasError('publicationDate')"
                    :error-messages="getError('publicationDate')"
                    label="Дата публикации"
                    required
                    type="date"
                    v-model="value.publicationDate"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </v-layout>

                <v-divider class="mt-1"></v-divider>

              </div>
              <div v-if="setDisable('3')">
                <ListReview_organization v-if="value.id"
                  v-bind:candidateCase= value.id
                  v-bind:disable=true>
                </ListReview_organization>
                <ListReview_opponent v-if="value.id"
                  v-bind:candidateCase= value.id
                  v-bind:disable=true>
                </ListReview_opponent>
                <ListReview_person v-if="value.id"
                  v-bind:candidateCase= value.id
                  v-bind:disable=true>
                </ListReview_person>
                <v-divider class="mt-1"></v-divider>
              </div>
              <div v-if="setDisable('5')">
                <FileInput
                  v-bind:fieldLabel="'Протокол заседания диссертационного совета по защите'"
                  v-bind:field="'councilProtectionProtocol'"
                  v-bind:file=value.councilProtectionProtocol
                  @updateFile="updateFile"
                  v-bind:error="hasError('councilProtectionProtocol')"
                  v-bind:error_messages="getError('councilProtectionProtocol')"
                  v-bind:template="setTemplUrl('case.CandidateCase.councilProtectionProtocol')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Явочный лист заседания диссертационного совета по защите'"
                  v-bind:field="'councilProtectionLeafSheet'"
                  v-bind:file=value.councilProtectionLeafSheet
                  @updateFile="updateFile"
                  v-bind:error="hasError('councilProtectionLeafSheet')"
                  v-bind:error_messages="getError('councilProtectionLeafSheet')"
                  v-bind:template="setTemplUrl('case.CandidateCase.councilProtectionLeafSheet')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Протокол счетной комиссии заседания диссертационного совета по защите'"
                  v-bind:field="'countingCommissionProtectionProtocol'"
                  v-bind:file=value.countingCommissionProtectionProtocol
                  @updateFile="updateFile"
                  v-bind:error="hasError('countingCommissionProtectionProtocol')"
                  v-bind:error_messages="getError('countingCommissionProtectionProtocol')"
                  v-bind:template="setTemplUrl('case.CandidateCase.countingCommissionProtectionProtocol')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Заключение диссертационного совета по защите'"
                  v-bind:field="'councilProtectionConclusion'"
                  v-bind:file=value.councilProtectionConclusion
                  @updateFile="updateFile"
                  v-bind:error="hasError('councilProtectionConclusion')"
                  v-bind:error_messages="getError('councilProtectionConclusion')"
                  v-bind:template="setTemplUrl('case.CandidateCase.councilProtectionConclusion')"
                ></FileInput>

                <v-divider class="mt-1"></v-divider>
              </div>
              <div v-if="setDisable('9')">
                <v-layout class="mt-1">
                  <v-flex md6>
                    <v-text-field
                      :error="hasError('certificationCommissionMeetingDate')"
                      :error-messages="getError('certificationCommissionMeetingDate')"
                      label="Дата заседания аттестационной комисси"
                      required
                      type="date"
                      v-model="value.certificationCommissionMeetingDate"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <FileInput
                      v-bind:fieldLabel="'Выписка из протокола заседания аттестационной комиссии'"
                      v-bind:field="'certificationCommissionProtocol'"
                      v-bind:file=value.certificationCommissionProtocol
                      @updateFile="updateFile"
                      v-bind:error="hasError('certificationCommissionProtocol')"
                      v-bind:error_messages="getError('certificationCommissionProtocol')"
                    ></FileInput>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-1"></v-divider>
              </div>
              <div v-if="setDisable('10')">
                <v-layout wrap>
                  <v-flex md6>
                    <v-text-field
                      :error="hasError('rectorOrderNumber')"
                      :error-messages="getError('rectorOrderNumber')"
                      label="Номер приказа ректора о выдаче диплома"
                      required
                      v-model="value.rectorOrderNumber"
                      class="pa-1 ma-1"
                    ></v-text-field>

                    <v-text-field
                      :error="hasError('rectorOrderDate')"
                      :error-messages="getError('rectorOrderDate')"
                      label="Дата приказа ректора о выдаче диплома"
                      required
                      type="date"
                      v-model="value.rectorOrderDate"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      :error="hasError('diplomaSeries')"
                      :error-messages="getError('diplomaSeries')"
                      label="Серия бланка диплома об ученой степени"
                      required
                      v-model="value.diplomaSeries"
                      class="pa-1 ma-1"
                    ></v-text-field>

                    <v-text-field
                      :error="hasError('diplomaNumber')"
                      :error-messages="getError('diplomaNumber')"
                      label="Номер бланка диплома об ученой степени"
                      required
                      v-model="value.diplomaNumber"
                      class="pa-1 ma-1"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <FileInput
                  v-bind:fieldLabel="'Приказ ректора о выдаче диплома'"
                  v-bind:field="'rectorOrder'"
                  v-bind:file=value.rectorOrder
                  @updateFile="updateFile"
                  v-bind:error="hasError('rectorOrder')"
                  v-bind:error_messages="getError('rectorOrder')"
                  v-bind:template="setTemplUrl('case.CandidateCase.rectorOrder')"
                ></FileInput>

                <FileInput
                  v-bind:fieldLabel="'Копия диплома'"
                  v-bind:field="'diploma'"
                  v-bind:file=value.diploma
                  @updateFile="updateFile"
                  v-bind:error="hasError('diploma')"
                  v-bind:error_messages="getError('diploma')"
                  v-bind:template="setTemplUrl('case.CandidateCase.diploma')"
                ></FileInput>
              </div>
              <v-layout wrap>
                <v-autocomplete
                  :error="hasError('status')"
                  :error-messages="getError('status')"
                  :items="selectors.nextStatus"
                  label="Статус дела"
                  v-model="value.status"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                  :disabled="isSendCorrect"
                ></v-autocomplete>

                <v-flex md6>
                  <v-card flat style="height: 15vh; overflow-y: scroll">
                    <template v-for="item in historyStatus">
                      <v-card class="pa-1" color="grey lighten-2" flat>
                        <v-card-title class="pa-1 text-xs-left">
                          {{findNameObj('status',item.status)}}
                          - {{displayDate(item.setDate,true)}}
                        </v-card-title>
                      </v-card>
                    </template>

                  </v-card>
                </v-flex>
              </v-layout>

            </div>
          <div  v-if="!isOnlyRead()">
            <v-btn :disabled="isSendCorrect" @click="apply"   :loading=loader  color="primary" block>Сохранить</v-btn>
          </div>

          </v-card-text>
          <v-progress-circular v-else class="mt-3"
                               :size="70"
                               color="primary"
                               indeterminate
          />
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog @input="loadAddPerson" v-model="addPerson" width="500" persistent>
      <Person @addItem="loadAddPerson"
              @ended="addPerson = false"
              @refreshItem="loadAddPerson"
              v-if="addPerson"
      >
      </Person>
    </v-dialog>
    <v-dialog @input="loadAddOrganization" v-model="addOrganization" width="500" persistent>
      <Organization @addItem="loadAddOrganization"
                    @ended="addOrganization = false"
                    @refreshItem="loadAddOrganization"
                    v-if="addOrganization"
      >
      </Organization>
    </v-dialog>

    <v-layout justify-center row>
      <v-dialog max-width="290" persistent v-model="successPathBool">
        <v-card>
          <v-card-title class="headline">Изменение анкеты</v-card-title>
          <v-card-text>Данные анкеты были успешно измененны
          </v-card-text>
          <v-card-actions>
            <v-btn @click="successPathBool = false" block color="green darken-1">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="290" persistent v-model="check">
        <v-card>
          <v-card-title class="headline">Изменение даты</v-card-title>
          <v-card-text>Дорогой друг, ты учёл время на рассылку автореферата?
          </v-card-text>
          <v-card-actions>
            <v-btn @click="check = false" block color="green darken-1">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="290" persistent v-model="setStatus">
        <v-card>
          <v-card-title class="headline">Изменение статуса</v-card-title>
          <v-card-text>Вы уверены в изменении статуса?
          </v-card-text>
          <v-card-actions>
            <v-btn @click="setNewStatus(false)" block color="red darken-1">НЕТ</v-btn>
            <v-btn @click="setNewStatus(true)" block color="green darken-1">ДА</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-form>
</template>


<script>

  // import urls from "../../../../../urls"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import UserDataMixin from '../../../mixins/UserDataMixin'
  import {makeGetRequest, makePostRequestFile, makePostRequest, isOnlyReadPermission,getPermission} from "../../../helper";
  import FileInput from "../../diss/components/FileInput"
  import moment from 'moment'
  import ListReview_opponent from '../../diss/pages/adminPage/page/ListReview_opponent.vue'
  import ListReview_organization from '../../diss/pages/adminPage/page/ListReview_organization.vue'
  import ListReview_person from '../../diss/pages/adminPage/page/ListReview_person.vue'
  import Person from "../../diss/pages/adminPage/forms/Person"
  import Organization from "../../diss/pages/adminPage/forms/Organization"
  import urls from "../../../modules/petition/urls"

  export default {
    name: "ProgressApplication",
    mixins: [UserDataFormMixin, UserDataMixin],
    components: {FileInput, ListReview_opponent,ListReview_person,ListReview_organization, Person, Organization},
    props: {
      id: Number,
      lastName: Array,
      firstName: Array,
      patronymic: Array,
      thesisTopic: Array,
    },


    data() {
      return {
        historyStatus: [], // история статусов
        check: false, // открытие  диалога для подсказки с датой
        addPerson: false, // открвтие диалога с добавлением персоны
        addOrganization: false, // открвтие диалога с добавлением организации
        menu: false, // диалог выбора даты
        firstLoad: true, // вспомогательный буль для отслеживания загрузки
        setStatus: false, // открвтие диалога с изменением статуса
        oldStatus: null, // храним старый статус
        endStatus: false,
        //переменные для окошка успеха
        loader : false,
        successPathBool: false,
        //переменные для отзывов
        URL_DELETE: process.env.VUE_APP_API_HOST + "council/admin/case/models/review/<id>/",
        opened_form: false,
        loading: true,
        total: 0,
        items: [],
        pagination: {},
        selected: {},
        headers: [

          {
            text: 'Оппонент/Организация/Сторонее лицо', sortable: false, align: 'justify-center',
            // class: 'headline'
          },
          {
            text: 'Тип документа для отзыва', sortable: false, align: 'justify-center',
            // class: 'headline'
          },
          {
            text: 'Файл', sortable: false, align: 'justify-center',
            // class: 'headline'
          },
          {
            text: 'Действия', sortable: false, align: 'justify-center',
            // class: 'headline'
          }
        ],
        //все для анкеты
        URL_CREATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/",
        URL_UPDATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/<id>/",
        lang: [],

        selectors: {
          reviewType: [],
          academicDegree: [],
          organization: [],
          scientificBoss: [],
          scientificField: [],
          dissertationCouncil: [],
          location: [],
          status: [],
          nextStatus: [],
          file_fileds: [],
        },

        value: {
          id: null,
          status: null,
          lastName: [],
          firstName: [],
          patronymic: [],
          birthday: null,
          thesisTopic: [],
          language: null,
          academicDegree: null,
          scientificField: [
            {
              scientificField: null,
            }],
          organization: null,
          scientificBoss: null,
          scientificConsultant: null,
          statement: null,
          eduDoc: null,
          examDoc: null,
          organizationConclusion: null,
          expertPublicationConclusion: null,
          expertTradeConclusion: null,
          personalDataConsent: null,
          passport: null,
          dissertationCouncil: null,
          thesisPDF: null,
          thesisWORD: null,
          synopsis: null,
          annotation: null,
          expertInternetPublicationConclusion: null,
          expertReviewConclusion: null,
          councilReviewProtocol: null,
          councilReviewLeafSheet: null,
          location: null,
          room: null,
          protectionDate: null,
          publicationDate: null,
          councilProtectionProtocol: null,
          councilProtectionLeafSheet: null,
          countingCommissionProtectionProtocol: null,
          councilProtectionConclusion: null,
          certificationCommissionProtocol: null,
          certificationCommissionMeetingDate: null,
          rectorOrder: null,
          rectorOrderNumber: null,
          rectorOrderDate: null,
          diplomaSeries: null,
          diplomaNumber: null,
          diploma: null,
        },

      }
    },
    watch: {


      'value.protectionDate': function (newValue, oldValue) {
        if (!this.firstLoad )
          this.check = true
        this.firstLoad = false;
      },

      'value.status': function (newValue, oldValue) {
        if (oldValue !== null && newValue !== null )
          this.setStatus = true;
      },
    },
    computed: {
      ruleDateMax() {
        return this.ruleDate(true)
      },
      ruleDateMin() {
        return this.ruleDate(false)
      },
      // геттер вычисляемого значения
      textAcadem() {
        if (this.value.scientificField[0] === undefined)
          return "";
        if (this.value.scientificField[0].scientificField === null || this.value.scientificField[0].scientificField === undefined) {
          return "";
        } else {
          var lists = this.value.scientificField
          let name = ""
          for (let str in lists) {
            name = this.selectors.scientificField.find(x => x.value === lists[str].scientificField);
          }
          if (name !== undefined) {
            let patt = /\(([^\(\)]+)\)/gmi;
            let pp = patt.exec(name.text);
            return pp[1];
          }
          return " ";
        }
      },
      isSendCorrect() {
        let isNotSend = false;
        let step2 = ["thesisPDF",
          "synopsis",
          "annotation",
          "expertInternetPublicationConclusion",
          "expertReviewConclusion",
          "councilReviewProtocol",
          "councilReviewLeafSheet"];

        let step3 = ["location",
          "room",
          "protectionDate",
          "publicationDate"
        ];

        let step5 = [
          "councilProtectionProtocol",
          "councilProtectionLeafSheet",
          "countingCommissionProtectionProtocol",
          "councilProtectionConclusion",
        ]
        let step9 = [
          "certificationCommissionProtocol",
          "certificationCommissionMeetingDate",
        ]

        let step10 =
          [
            "rectorOrderNumber",
            "rectorOrderDate",
            "rectorOrder",
            "diplomaSeries",
            "diplomaNumber",
            "diploma",
          ]

        if (this.value.status === "2") {
          isNotSend = this.isSendData(step2);
        }
        if (this.value.status === "3") {
          isNotSend = this.isSendData(step3);
        }
        if (this.value.status === "5") {
          isNotSend = this.isSendData(step5);
        }
        if (this.value.status === "9") {
          isNotSend = this.isSendData(step9);
        }
        if (this.value.status === "10") {
          isNotSend = this.isSendData(step10);
        }

        return isNotSend
      }
    },

    methods: {
      isSecretary(){
        let role = getPermission()
        if (role.length === 1)
          return role.find(obj => Number(obj) ===  1)
        else
          return false
      },
      isOnlyRead(){
        // console.log(1,(this.isSecretary() &&  Number(this.value.status) > 2) || !this.isSecretary())
        // console.log(2,(this.isSecretary() &&  Number(this.value.status) > 2) )
        // console.log(3,  this.isSecretary())
        // console.log(4,( Number(this.value.status) > 2) )
        return isOnlyReadPermission()
      },


      setNewStatus(isUpdate) {

        if (isUpdate) {
          this.setStatus = false
          this.apply()
        } else {
          this.setStatus = false
          this.value.status = null;
          this.loadData()

        }
      },

//правила на отображение даты
      ruleDate(max = true) {
        var D = new Date();
        D.setMonth(D.getMonth() + 2)
        if (max)
          D.setMonth(D.getMonth() + 11);
        else
          D.setMonth(D.getMonth() - 1);
        let format = 'YYYY-MM-DD'
        return moment(D).format(format)
      },

//частичная проверк полей на отправку
      isSendData(mass) {
        let isNotSend = false;
        for (var key in mass) {
          if (this.value[mass[key]] === undefined || this.value[mass[key]] === null)
            isNotSend = true;
        }
        return isNotSend;
      },

      setDisable(status) {

        if (this.value.status !== null) {
          if (Number(this.value.status) >= Number(status))
            return true;
          else
            return false;
        } else
          return false;

      },
      loadAddOrganization() {
        this.addOrganization = false;
        this.selectors.organization = [];
        let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
        this.load(this, url, "organization")
      },
      loadAddPerson() {
        this.addPerson = false;
        this.selectors.scientificBoss = [];
        let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/";
        this.load(this, url, "scientificBoss")
      },

      //Вывод даты
      displayDate: function (date, minutes = false) {
        let format = 'DD.MM.YYYY'
        if (minutes)
          format += ' HH:mm'
        return moment(date).format(format)
      },

//история статусов
      LoadHistoryStatus() {
        let url = process.env.VUE_APP_API_HOST + "council/admin/case/models/status_history" + "?candidateCase=" + this.$route.params.id
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.historyStatus = json
        })
      },
//сигнал от компонента файлов
      updateFile(item) {
        this.value[item.field] = item.file;
      },
//выбор файла
      setFile(e, field, i = undefined, field_str = undefined) {
        if (i === undefined) {
          const file = e.target.files[0];
          this.value[field] = file;
        } else {
          const file = e.target.files[0];
          this.value[field][i][field_str] = file;
        }

      },
//универсальное добавление поля
      addField(field) {
        this.value[field].push(
          {
            [field]: null,
          }
        )
      },

      addField_scientific_consultant() {
        if (this.value.scientificConsultant === null)
          this.value.scientificConsultant = []
        this.value.scientificConsultant.push(
          {
            "person": null,
            "review": null,
          }
        )
      },
      addField_scientific_boss() {
        if (this.value.scientificBoss === null)
          this.value.scientificBoss = []
        this.value.scientificBoss.push(
          {
            "person": null,
            "review": null,
          }
        )
      },
      //удаление поля
      deleteData(idx, key, allDelete = false) {
        if (this.value[key].length > 1 || allDelete)
          this.value[key].splice(idx, 1);
      },
      //рекурсивная загрузка пагинации
      load: function (app, url, data) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[data].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url, data);
          });
      },
      //загрузка селекторов
      loadSelector(data, url) {
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.selectors[data] = json
        })
      },

      text: item => item.name[0].text,
      //язык текущего поля
      findLang(langid) {
        let str = this.lang.find(x => x.id === langid).name;
        return str
      },
      closeDialog() {
        this.$emit('ended', '')
      },

      //отправка на сервер данных
      apply: function () {
        this.loader  = true;
//массив файловых полей
        let file_mass = ["statement", "eduDoc", "examDoc", "organizationConclusion",
          "expertPublicationConclusion", "expertTradeConclusion", "personalDataConsent",
          "passport", "thesisPDF", "synopsis", "annotation", "expertLangConclusion",
          "expertExtremismConclusion", "expertReviewConclusion", "councilReviewProtocol",
          "councilReviewLeafSheet", "councilProtectionProtocol",
          "councilProtectionLeafSheet",
          "countingCommissionProtectionProtocol",
          "councilProtectionConclusion", "expertInternetPublicationConclusion",
          "certificationCommissionProtocol", "rectorOrder", "diploma"]

        let url = this.URL_UPDATE.replace('<id>', this.$route.params.id);
        let method = 'PATCH'
        // let method = 'PUT'
        let data = Object.assign({}, this.value);

        var formData = new FormData();

        for (var key in data) {
          let loadflag = true  //файл не является строкой и реален

          if (data[key] !== undefined && data[key] !== null) {

            for (var i = 0; i < file_mass.length; i++) {

              if (file_mass[i] === key) {
                if (typeof data[key] === 'string') {//если файл строка,то не грузим
                  // formData.append(key, data[key])
                  loadflag = false
                } else {
                  if ((typeof data[key] !== 'object') && (typeof data[key] !== 'string'))
                    data[key] = new File(['/path/to/file'], 'rb')//пихаем пустоту,но как файл
                }
              }
            }

            if (key === "lastName" || key === "firstName" || key === "patronymic"
              //json формируем и отправляем
              || key === "thesisTopic"
            ) {
              let param = data[key];
              let loadFlag = true
              for (var i in param) {
                if (param[i].text === '') {
                  loadFlag = false
                }
              }
              if (loadFlag)
                formData.append(key, JSON.stringify(data[key]))
              else
                formData.append(key, JSON.stringify({}))
            } else if (key === "scientificConsultant") {
              var list = data["scientificConsultant"]
              for (let str in list) {
                let name_strperson = "scientificConsultant[" + str + "]person"  //вложенные данные отправляем плоско
                formData.append(name_strperson, list[str].person)
                if (typeof list[str].review !== 'string' && list[str].review !== null) { //не отправляем строки
                  let name_strreview = "scientificConsultant[" + str + "]review"
                  formData.append(name_strreview, list[str].review)
                }
              }
            } else if (key === "scientificBoss") {
              var list = data["scientificBoss"]
              for (let str in list) {
                let name_strperson = "scientificBoss[" + str + "]person"  //вложенные данные отправляем плоско
                formData.append(name_strperson, list[str].person)
                if (typeof list[str].review !== 'string' && list[str].review !== null) { //не отправляем строки
                  let name_strreview = "scientificBoss[" + str + "]review"
                  formData.append(name_strreview, list[str].review)
                }
              }
            } else if (key === "scientificField") { // м2м отправка плоско
              var lists = data["scientificField"]
              for (let str in lists) {
                let name_scientific = "scientificField[" + str + "]scientificField"
                formData.append(name_scientific, lists[str].scientificField)
              }

            } else{
              if (loadflag) // остальные поля
                formData.append(key, data[key])
            }

          }
        }

        let status = true;
        makePostRequestFile(url, formData, method)
          .then(resp => {
            if (!resp.ok) {
              status = false;
              this.loader  = false;
            }
            return resp.json()
          })
          .then(json => {
            this.loader  = false;
            if (status) {
              this.loadData()
              this.successPathBool = true
              this.errors = {}
            } else {
              this.receiveErrors(json);
              if (json.detail) {
                var detail = confirm(json.detail);
              }
              if (json.non_field_errors) {
                var non_field_errors = confirm(json.non_field_errors);
              }
            }
          })

      },
      //имя по ид для селектров объектов
      findNameObj(edit, id) {
        let obj = this.selectors[edit].find(item => item.value === id);
        if (obj !== undefined) {
          return obj.text
        } else {
          return ""
        }
      },
      loadStatus() {

        makeGetRequest(process.env.VUE_APP_API_HOST + "council/admin/case/status_info/").then(resp => {
          let sys = true;
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {

          let data = json
          let sys = true;
          makeGetRequest(process.env.VUE_APP_API_HOST + "council/admin/case/choices/status_choices/").then(resp => {
            if (!resp.ok) {
              sys = false
            }
            return resp.json()
          }).then(json => {
            this.selectors.status = json
            let dataStatus = this.selectors.status //получили все статусы
            this.selectors.nextStatus = []
            this.selectors.nextStatus.push(this.selectors.status[this.value.status]) // текущий статус
            let next_statuses = data[this.value.status] //получили все следующие статусы
            if (next_statuses !== undefined){
              for (let key in dataStatus) { // ищем будующие статусы
                let i = next_statuses.find(item => item == key);
                if (i !== undefined) {
                  this.selectors.nextStatus.push(this.selectors.status[i])
                }
              }
            }
          })
        })
      },
      loadData() {
        this.firstLoad = true;
        this.value.status = null;
        let url = this.URL_UPDATE.replace('<id>', this.$route.params.id);
        var sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.value = json
          this.value.lastName = json.lastName
          this.value.firstName = json.firstName
          if(Array.isArray(json.patronymic)){
            this.value.patronymic = json.patronymic
          }else{
            this.value.patronymic =[]
            for (let key in this.lang) {
              this.value.patronymic.push({"text": "", "language": this.lang[key].id})
            }
          }
          this.value.thesisTopic = json.thesisTopic
          this.value.language = json.language.id
          this.value.status = json.status.status
          this.value.academicDegree = json.academicDegree.id
          this.value.organization = json.organization.id
          this.value.scientificBoss = []
          if (json.dissertationCouncil !== null)
            this.value.dissertationCouncil = json.dissertationCouncil.id

          let urlsci = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case_scientific_field/")

          let params = json.scientificField.get_params

          json.scientificField.get_params.page_size = 100

          urlsci.search = new URLSearchParams(params).toString();
          this.loadStatus()
          this.LoadHistoryStatus()
          makeGetRequest(urlsci).then(resp => {
            if (!resp.ok) {
              sys = false
            }
            return resp.json()
          }).then(json => {
            let res = json.results

            if (res.length > 0) {
              this.value.scientificField = []
              for (let key in res) {

                this.value.scientificField.push(
                  {"scientificField": res[key].scientificField}
                )
              }
            } else {
              this.value.scientificField = []
              this.value.scientificField.push(
                {"scientificField": null}
              )
            }

          })

          let urlcon = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/scientific_consultant/")

          json.scientificConsultant.get_params.page_size = 100
          params = json.scientificConsultant.get_params
          urlcon.search = new URLSearchParams(params).toString();

          makeGetRequest(urlcon).then(resp => {
            if (!resp.ok) {
              sys = false
            }
            return resp.json()
          }).then(json => {
            let res = json.results

            this.value.scientificConsultant = []

            for (let key in res) {

              this.value.scientificConsultant.push(
                {
                  "person": res[key].person,
                  "review": res[key].review,
                }
              )
            }
          })


          urlcon = new URL(process.env.VUE_APP_API_HOST + "council/admin/case/models/scientific_boss/")

          urlcon.search = new URLSearchParams(params).toString();

          makeGetRequest(urlcon).then(resp => {
            if (!resp.ok) {
              sys = false
            }
            return resp.json()
          }).then(json => {
            let res = json.results

            this.value.scientificBoss = []

            for (let key in res) {

              this.value.scientificBoss.push(
                {
                  "person": res[key].person,
                  "review": res[key].review,
                }
              )
            }
          })


        })
      },
      setTemplUrl(type) {
        let name = this.selectors.file_fileds.filter(function (element) {
          return element.field === type;
        });
        if (name.length === 0)
          return undefined
        else
          return name
      },
    },
    created() {
      let url = process.env.VUE_APP_API_HOST + "council/admin/core/models/language/"
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.lang = json

        if (this.value.lastName.length === 0) {
          for (let key in this.lang) {
            this.value.lastName.push({"text": "", "language": this.lang[key].id})
            this.value.firstName.push({"text": "", "language": this.lang[key].id})
            this.value.patronymic.push({"text": "", "language": this.lang[key].id})
            this.value.thesisTopic.push({"text": "", "language": this.lang[key].id})
          }
        }

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/academic_degree/"
        this.loadSelector("academicDegree", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/scientific_field/"
        this.loadSelector("scientificField", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
        this.load(this, url, "organization")

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/"
        this.load(this, url, "scientificBoss")

        url = process.env.VUE_APP_API_HOST + "council/admin/diss/selectors/dissertation_council/"
        this.loadSelector("dissertationCouncil", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/case/choices/doc_type_choices/"
        this.loadSelector("reviewType", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/case/choices/location_choices/"
        this.loadSelector("location", url)

        url = urls.getUrl('admin|core|models|document_template-list', 'list'),
          this.load(this, url, "file_fileds")

        this.$store.commit('mainpage/changeTitle', 'Заявка');
        this.loadData()
      })
    }
  }


</script>

<style scoped>

</style>
